import InterestLevel1 from 'images/logo-rating-level1.png';
import InterestLevel2 from 'images/logo-rating-level3.png';
import InterestLevel3 from 'images/logo-rating-level5.png';

export const interestLevels = {
  0: {
    description: '',
    imagePath: '',
  },
  1: {
    description: 'Average',
    imagePath: InterestLevel1,
  },
  2: {
    description: 'Active',
    imagePath: InterestLevel2,
  },
  3: {
    description: 'Very Active',
    imagePath: InterestLevel3,
  },
};
